import React, { useState } from "react";

//UI Material
import { Box, Card, Grid, Tab, Tabs } from "@mui/material";

//Helpers
import {
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";

//Local components
import AllProductsMonthlyProductionGraph from "../Graphs/AllProductsMonthlyProductionGraph";

//Function to generate tabs
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`total-products-tabpanel-${index}`}
      aria-labelledby={`total-products-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{typographyForText(children)}</Box>}
    </div>
  );
}

export default function TotalMonthlyProduction({ data, year }) {
  // ==========> Component States <==========
  //State for graph variant
  const [type, setType] = useState(0);

  // ==========> Component Functions <==========
  //Function to set tab value
  const handleChange = (_event, newValue) => {
    setType(newValue);
  };
  const changeTab = handleChange;

  //Function for giving an index to each tab
  function a11yProps(index) {
    return {
      id: `total-products-tab-${index}`,
      "aria-controls": `total-products-tabpanel-${index}`,
    };
  }

  // ==========> Component <==========
  return (
    <Card raised sx={{ height: "100%" }}>
      <Grid container spacing={1} textAlign="center" sx={{ padding: "15px" }}>
        <Grid item xs={12}>
          {typographyForSubtitles(
            `Producción Total mensual de ${year}`,
            "secondary"
          )}
        </Grid>
        <Grid item xs={12}>
          <Box>
            <Tabs
              centered
              indicatorColor="secondary"
              textColor="secondary"
              value={type}
              onChange={changeTab}
              aria-label="product-tabs"
            >
              <Tab
                label="Estaciones"
                sx={{ fontSize: "11px" }}
                {...a11yProps(0)}
              />
              <Tab
                label="Accesorios y otros"
                sx={{ fontSize: "11px" }}
                {...a11yProps(1)}
              />
              <Tab label="Todo" sx={{ fontSize: "11px" }} {...a11yProps(2)} />
            </Tabs>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <TabPanel value={type} index={0}>
            <AllProductsMonthlyProductionGraph
              data={data}
              year={year}
              product={"estaciones"}
            />
          </TabPanel>
          <TabPanel value={type} index={1}>
            <AllProductsMonthlyProductionGraph
              data={data}
              year={year}
              product={"accesorios"}
            />
          </TabPanel>
          <TabPanel value={type} index={2}>
            <AllProductsMonthlyProductionGraph
              data={data}
              year={year}
              product={"todos"}
            />
          </TabPanel>
        </Grid>
      </Grid>
    </Card>
  );
}
